import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * Convert prop from flexible array format to raw value
 */
export var NodeProjection = /*#__PURE__*/function () {
  function NodeProjection(active, children, props, styles, params) {
    _classCallCheck(this, NodeProjection);
    this.active = active;
    this.children = children;
    this.props = props;
    this.styles = styles;
    this.params = params;
  }
  _createClass(NodeProjection, [{
    key: "evaluate",
    value: function evaluate(ctx) {
      return {
        nodeId: this.params.nodeId,
        componentId: this.params.componentId,
        active: this.active.evaluate(ctx),
        children: this.children.evaluate(ctx),
        props: this.props.evaluate(ctx),
        styles: this.styles.evaluate(ctx)
      };
    }

    // getParentId(ctx) {
    // }
    //
    // getChildren(ctx) {
    // }
    //
    // getProps(ctx) {
    // }
    //
    // getStyles(ctx) {
    // }
  }]);
  return NodeProjection;
}();